import React from "react";
import { useTheme } from "styled-components";

import { Emoji } from "emoji-mart";

import Icon, { getIconType } from "../../../../components/ui/icon/Icon";
import { ButtonContainer, ButtonIconContainer } from "./styles";
import { TEXT_ELEMENTS } from "./defaults";
import { options } from "../../style-options";
import { StyledEditableInput } from "../../../../components/inline-edit/styled";
import {
  BUTTON_PROP,
  BUTTON_TYPE,
} from "../../../../optics/components/drawers/settings/features/button/defaults";
import { buttonStores } from "../../../../stores/export-stores";
import { MACRO_KEY } from "../../../../optics/defaults";

export const Button = ({
  data,
  isEditable = false,
  onClick = () => {},
  editorMacro = MACRO_KEY.BUTTON,
}) => {
  const hasLabel = TEXT_ELEMENTS.includes(data.type);
  const setData = buttonStores[editorMacro]((state) => state.setData);
  const showIcon =
    data[BUTTON_PROP.TYPE] === BUTTON_TYPE.ICON ||
    data[BUTTON_PROP.TYPE] === BUTTON_TYPE.TEXT_AND_ICON;

  const iconType = getIconType(data.icon);

  const theme = useTheme();

  return (
    <ButtonContainer
      onClick={() => {
        if (!isEditable) {
          onClick();
        }
      }}
      backgroundColor={data.backgroundColor[theme.name]}
      borderRadius={data.corners}
      color={data.labelColor[theme.name]}
      border={data.border[theme.name]}
      size={data.size}
      iconPosition={data.iconPosition}
      type={data.type}
      className="macrosuite-button"
    >
      {showIcon && (
        <ButtonIconContainer
          size={data.size}
          type={data.type}
          iconPosition={data.iconPosition}
        >
          {iconType === "emoji" && (
            <Emoji
              emoji={data.icon}
              size={options.size[data.type][data.size].iconSize}
            />
          )}

          {iconType === "icon" && (
            <Icon
              icon={data.icon}
              size={options.size[data.type][data.size].iconSize}
            />
          )}

          {iconType === "app" && (
            <img
              src={data.icon}
              alt="img"
              height={options.size[data.type][data.size].iconSize}
            />
          )}
        </ButtonIconContainer>
      )}
      {hasLabel && (
        <>
          {isEditable ? (
            <StyledEditableInput
              size={data.label?.length || 0}
              value={data.label}
              onChange={(e) => setData({ label: e.target.value })}
              style={{ textAlign: "center" }}
            />
          ) : (
            data.label
          )}
        </>
      )}
    </ButtonContainer>
  );
};
